import {Button} from 'alm-react-components';
import {useNavigate} from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MembershipFailure = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-col gap-12 justify-center h-screen  md-ma px-4 items-center">
        <div className=""><span dangerouslySetInnerHTML={{ __html: (t("MembershipSuccess.yourSubscriptionFailed")) }} /></div>
        <div className="md:min-w-[486px] md:max-w-[486px]">
          <Button
            onClick={() => {
              navigate('/');
            }}
            className="w-full h-auto py-2 text-base mb-4 truncate block"
          >
            <span dangerouslySetInnerHTML={{ __html: t("MembershipSuccess.signOut") }} />
          </Button>
          <Button
            onClick={() => {
              navigate('/select-membership');
            }}
            className="w-full h-auto py-2 text-base mb-4 truncate block"
          >
            <span dangerouslySetInnerHTML={{ __html: t("MembershipSuccess.close") }} />
          </Button>
        </div>
      </div>
    </>
  );
};
export default MembershipFailure;
